/* eslint-disable  @typescript-eslint/no-explicit-any */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
var sortRefs = function (formId) {
    return function (a, b) {
        var formEl = document.getElementById(formId);
        var idxA = Array.prototype.indexOf.call(formEl, a.current);
        var idxB = Array.prototype.indexOf.call(formEl, b.current);
        return idxA - idxB;
    };
};
var errorKeys = function (errors) {
    return Object.entries(errors).reduce(function (acc, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (value) {
            return __spreadArray(__spreadArray([], __read(acc), false), [key], false);
        }
        return acc;
    }, []);
};
var getOrderedErrorRefs = function (refs, errors, formId) {
    var refsArr = Object.entries(refs).reduce(function (acc, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (errorKeys(errors).includes(key)) {
            return __spreadArray(__spreadArray([], __read(acc), false), [value], false);
        }
        return acc;
    }, []);
    return refsArr.sort(sortRefs(formId));
};
var getInvalidStringRegEx = function (isName, base, names, substring) {
    var normalized = isName ? base.filter(function (s) { return !names.includes(s); }) : base;
    var baseRegexString = "\\b".concat(normalized.join('\\b|\\b'), "\\b");
    var regexString = substring.length
        ? "".concat(baseRegexString, "|").concat(substring.join('|'))
        : baseRegexString;
    return new RegExp(regexString, 'gi');
};
export var getIsInvalidStringWithList = function (_a) {
    var _b = _a.base, base = _b === void 0 ? [] : _b, _c = _a.names, names = _c === void 0 ? [] : _c, _d = _a.substring, substring = _d === void 0 ? [] : _d;
    return function (value, willCheck, isName) {
        /** Regex taken from
         * https://bitbucket.int.ally.com/projects/AOS/repos/ally-online-services/browse/packages/utils/addon/services/invalid-strings.js
         */
        // if the API call fails and base, therefore, defaults to an empty array,
        // allow all invalid string validations to pass
        if (!base.length) {
            return false;
        }
        var invalidStringRegex = getInvalidStringRegEx(isName, base, names, substring);
        if (willCheck && typeof value === 'string') {
            var normalizedValue = value
                .replace(/[\s_]+/g, ' ')
                .replace(/^\s|\s$/g, '');
            var isInvalid = !!normalizedValue.match(invalidStringRegex);
            return isInvalid;
        }
        return false;
    };
};
var isMatch = function (testKey, key) { return testKey === key; };
var getValidationOpts = function (fieldKeys, key) {
    return fieldKeys.reduce(function (acc, fieldKey) {
        var isString = typeof fieldKey === 'string';
        var isObject = typeof fieldKey === 'object';
        if (isString && isMatch(fieldKey, key)) {
            return { shouldCheck: true, isName: false };
        }
        if (!!fieldKey &&
            isObject &&
            isMatch(fieldKey.key, key)) {
            return {
                shouldCheck: true,
                isName: fieldKey.isName,
            };
        }
        return acc;
    }, { shouldCheck: false, isName: false });
};
var checkForInvalidStrings = function (_a, fields) {
    var invalidStrings = _a.invalidStrings, fieldKeys = _a.fieldKeys;
    var getIsInvalidString = getIsInvalidStringWithList(invalidStrings);
    var validate = Object.entries(fields).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        var isString = typeof value === 'string';
        var _d = getValidationOpts(fieldKeys, key), shouldCheck = _d.shouldCheck, isName = _d.isName;
        var willCheck = shouldCheck && isString;
        var isInvalid = getIsInvalidString(value, willCheck, isName);
        var message = 'We’ve flagged one of the words you used in your response as abusive language. Try again without that word.';
        if (shouldCheck && isInvalid) {
            return __assign(__assign({}, acc), (_b = {}, _b[key] = message, _b));
        }
        return acc;
    }, {});
    return validate;
};
export var getNewErrors = function (values, validate, invalidStringsOpts, 
// @ts-ignore
changedValues, ensureValidation) {
    if (changedValues === void 0) { changedValues = {}; }
    /**
     * ternary that dictates validation object
     *
     * if we want the 'ensure validation' behavior then only validate dirty inputs
     * or the values we want to force validation on
     *
     * if not, validation happens with the standard `values` object
     */
    var valuesToValidate = ensureValidation
        ? Object.entries(changedValues).reduce(function (acc, key) {
            var _a;
            if (key[1] === true) {
                return __assign(__assign({}, acc), (_a = {}, _a[key[0]] = values[key[0]], _a));
            }
            return acc;
        }, {})
        : values;
    if (invalidStringsOpts) {
        return __assign(__assign({}, validate(valuesToValidate)), checkForInvalidStrings(invalidStringsOpts, valuesToValidate));
    }
    return validate(valuesToValidate);
};
export var useForm = function (_a) {
    var submit = _a.submit, submitError = _a.submitError, validate = _a.validate, initialState = _a.initialState, _b = _a.masks, masks = _b === void 0 ? {} : _b, formId = _a.formId, invalidStringsOpts = _a.invalidStringsOpts, ensureValidation = _a.ensureValidation;
    var valuesKeys = Object.keys(initialState);
    var initialErrorsState = valuesKeys.reduce(function (acc, key) {
        var _a;
        if (key) {
            return __assign(__assign({}, acc), (_a = {}, _a[key] = '', _a));
        }
        return acc;
    }, {});
    var initialChangedState = valuesKeys.reduce(function (acc, key) {
        var _a, _b;
        if (key) {
            if (
            // these will be passed in by consumer
            ensureValidation &&
                ensureValidation.includes(key)) {
                return __assign(__assign({}, acc), (_a = {}, _a[key] = true, _a));
            }
            return __assign(__assign({}, acc), (_b = {}, _b[key] = false, _b));
        }
        return acc;
    }, {});
    var initialRefState = React.useRef(function () {
        return valuesKeys.reduce(function (acc, key) {
            var _a;
            if (key) {
                var ref = React.createRef();
                return __assign(__assign({}, acc), (_a = {}, _a[key] = ref, _a));
            }
            return acc;
        }, {});
    }).current;
    var _c = __read(React.useState(initialState), 2), values = _c[0], setValues = _c[1];
    // Key/Value pair where key is the field name and value is a boolean of if the field has been changed
    var _d = __read(React.useState(initialChangedState), 2), changedValues = _d[0], setChangedValues = _d[1];
    var _e = __read(React.useState(initialErrorsState), 2), errors = _e[0], setErrors = _e[1];
    var _f = __read(React.useState(''), 2), formError = _f[0], setFormError = _f[1];
    var formErrorRef = React.useRef(null);
    var _g = __read(React.useState(initialRefState), 2), refs = _g[0], setRefs = _g[1];
    // the form isClean when it has not been interacted with yet
    var _h = __read(React.useState(true), 2), isClean = _h[0], setIsClean = _h[1];
    var _j = __read(React.useState({}), 2), maskedValues = _j[0], setMaskedValues = _j[1];
    var _k = __read(React.useState(false), 2), isReadyToSubmit = _k[0], setIsReadyToSubmit = _k[1];
    var handleSubmitError = function () {
        // run submitError callback provided by consumer
        if (submitError) {
            return submitError(errors);
        }
        var errorRefs = getOrderedErrorRefs(refs, errors, formId);
        var firstRef = errorRefs[0].current;
        // if there is only one error on submit, focus on errored input
        if (errorRefs.length === 1 && firstRef) {
            return firstRef.focus();
        }
        // if there are multiple errors on submit, focus on form-level error
        // message
        if (errorRefs.length > 1 && formErrorRef.current) {
            setFormError("There are ".concat(errorRefs.length, " errors in the form you submitted."));
            return formErrorRef.current.focus();
        }
        // if the formErrorRef is null on submit (i.e. it was never passed
        // to an error message container), focus on the first errored input
        if (firstRef) {
            return firstRef.focus();
        }
        return undefined;
    };
    React.useEffect(function () {
        var maybeSubmit = function () {
            setFormError('');
            var hasErrors = Object.values(errors)
                .map(function (error) { return !!error; })
                .includes(true);
            if (!hasErrors) {
                submit(values);
                return setIsReadyToSubmit(false);
            }
            handleSubmitError();
            return setIsReadyToSubmit(false);
        };
        if (isReadyToSubmit) {
            maybeSubmit();
        }
    }, [isReadyToSubmit, errors, submit, values]);
    var handleSubmit = function (event) {
        if (event)
            event.preventDefault();
        var newErrors = getNewErrors(values, validate, invalidStringsOpts, changedValues, ensureValidation);
        setErrors(newErrors);
        setIsReadyToSubmit(true);
    };
    var handleSetMaskedValue = function (name, value) {
        var maskFunc = masks[name];
        if (maskFunc) {
            var maskedValue_1 = maskFunc(value);
            setMaskedValues(function (vals) {
                var _a;
                var _b;
                return (__assign(__assign({}, vals), (_a = {}, _a[name] = {
                    isDisplayed: !!((_b = maskedValues[name]) === null || _b === void 0 ? void 0 : _b.isDisplayed),
                    value: maskedValue_1,
                }, _a)));
            });
        }
    };
    React.useEffect(function () {
        // Initialize all mask values on load
        Object.entries(initialState).forEach(function (_a) {
            var _b = __read(_a, 2), name = _b[0], value = _b[1];
            return handleSetMaskedValue(name, value);
        });
    }, []);
    var handleChange = function (event) {
        if (isClean)
            setIsClean(false);
        var _a = event.target, name = _a.name, value = _a.value;
        handleSetMaskedValue(name, value);
        setValues(function (vals) {
            var _a;
            return (__assign(__assign({}, vals), (_a = {}, _a[name] = value, _a)));
        });
        setChangedValues(function (changedVals) {
            var _a;
            return (__assign(__assign({}, changedVals), (_a = {}, _a[name] = true, _a)));
        });
    };
    var withMaskedValue = function (name) {
        var _a, _b;
        var maskedValue = (_a = maskedValues[name]) === null || _a === void 0 ? void 0 : _a.value;
        var isDisplayed = (_b = maskedValues[name]) === null || _b === void 0 ? void 0 : _b.isDisplayed;
        if (isDisplayed && maskedValue) {
            return maskedValue;
        }
        return values[name];
    };
    var setIsMaskedDisplayed = function (name, isDisplayed) {
        setMaskedValues(function (vals) {
            var _a;
            var _b;
            var value = (_b = vals[name]) === null || _b === void 0 ? void 0 : _b.value;
            // Only update mask if there is an existing value for that name
            return value
                ? __assign(__assign({}, vals), (_a = {}, _a[name] = {
                    value: value,
                    isDisplayed: isDisplayed,
                }, _a)) : vals;
        });
    };
    var clearValuesAndMaskedValues = function (key) {
        setValues(function (vals) {
            var _a;
            return __assign(__assign({}, vals), (_a = {}, _a[key] = '', _a));
        });
        setMaskedValues(function (vals) {
            var _a;
            return (__assign(__assign({}, vals), (_a = {}, _a[key] = {
                value: '',
                isDisplayed: false,
            }, _a)));
        });
    };
    /**
     * Will reset all or some of the form fields to an empty string
     *
     * **Usage:**
     *
     * call it with no arguments `resetFields()` to reset all fields
     *
     * call with field names `resetFields('username', 'ssn')` to reset the fields passed
     */
    var resetFields = function () {
        var fields = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fields[_i] = arguments[_i];
        }
        if (!fields.length) {
            return Object.keys(values).forEach(function (key) {
                clearValuesAndMaskedValues(key);
            });
        }
        return fields.forEach(function (key) {
            clearValuesAndMaskedValues(key);
        });
    };
    var handleFormattedChange = function (formatter) {
        return function (event) {
            var _a = event.target, name = _a.name, value = _a.value;
            var formattedValue = formatter(value);
            handleSetMaskedValue(name, formattedValue);
            setValues(function (vals) {
                var _a;
                return __assign(__assign({}, vals), (_a = {}, _a[name] = formattedValue, _a));
            });
        };
    };
    var validateFields = function (field) {
        var newErrors = __assign(__assign({}, errors), getNewErrors(field, validate, invalidStringsOpts));
        setErrors(newErrors);
    };
    /**
     * Will reset all or some of the form field errors to the intial state
     *
     * **Usage:**
     *
     * call it with no arguments `resetErrors()` to reset all field errors
     *
     * call with field names `resetErrors('username', 'ssn')` to reset the errors for fields passed
     */
    var resetErrors = function () {
        var fields = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fields[_i] = arguments[_i];
        }
        if (!fields.length) {
            setErrors(initialErrorsState);
        }
        else {
            var updates = fields.reduce(function (acc, key) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[key] = initialErrorsState[key], _a)));
            }, {});
            setErrors(__assign(__assign({}, errors), updates));
        }
    };
    return {
        handleChange: handleChange,
        handleFormattedChange: handleFormattedChange,
        handleSubmit: handleSubmit,
        values: values,
        maskedValues: maskedValues,
        validateFields: validateFields,
        errors: errors,
        setErrors: setErrors,
        resetErrors: resetErrors,
        formError: formError,
        setFormError: setFormError,
        formErrorRef: formErrorRef,
        refs: refs,
        setRefs: setRefs,
        setValues: setValues,
        resetFields: resetFields,
        withMaskedValue: withMaskedValue,
        setIsMaskedDisplayed: setIsMaskedDisplayed,
        isClean: isClean,
        changedValues: changedValues,
        setChangedValues: setChangedValues,
    };
};
//# sourceMappingURL=index.js.map